import { type PropsWithChildren, useRef, useState } from 'react';
import { InfoIcon } from 'lucide-react';

import { useAuthModal, VIEW_LOGIN } from '~/providers/auth-modal-provider';
import MyOCActions from '~/services/actions/myoc-actions';
import {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS } from
'~/services/actions/tracking-actions';
import { type Subscription } from '~/types/myoc';
import { trackEvent } from '~/utils/dataLayer';

import { Button, Dialog, Popover } from '../cxy';

import styles from './styles/Menu.module.css';

const AccountButton = ({ children }: PropsWithChildren) =>
<>
		<svg
    fill="none"
    height="18"
    viewBox="0 0 20 18"
    width="20"
    xmlns="http://www.w3.org/2000/svg">

			<path
      d="M14.4589 4.47141C14.4589 6.66205 12.5385 8.49282 10.0995 8.49282C7.66044 8.49282 5.74013 6.66205 5.74013 4.47141C5.74013 2.28076 7.66044 0.45 10.0995 0.45C12.5385 0.45 14.4589 2.28076 14.4589 4.47141Z"
      stroke="currentColor"
      strokeWidth="0.9" />

			<path
      d="M13.7032 9.6792C13.8525 9.59587 13.9952 9.54178 14.1258 9.52386C15.5923 9.32266 16.6629 10.1477 17.474 11.4808C18.288 12.8187 18.7698 14.5701 19.0421 15.9478C19.2074 16.7837 18.5501 17.55 17.6336 17.55H1.86107C1.03722 17.55 0.441044 16.9299 0.518176 16.2061C0.751772 14.014 1.70364 10.6286 5.25412 9.41485C5.57056 9.30667 5.93954 9.34702 6.28091 9.51709C7.84005 10.2938 8.96048 10.7808 10.0715 10.8319C11.2042 10.8841 12.2624 10.4834 13.7032 9.6792Z"
      stroke="currentColor"
      strokeWidth="0.9" />

		</svg>
		<span>{children}</span>
	</>;


const MenuList = ({
  isLoggedIn,
  subscriptions



}: {isLoggedIn: boolean;subscriptions?: Subscription[];}) => {
  const { openAtView } = useAuthModal();
  const ocActions = new MyOCActions({});

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const openAuthenticationModal = () => {
    isLoggedIn ? ocActions.logout() : openAtView(VIEW_LOGIN);

    const event = isLoggedIn ? TRACKING_EVENTS.LOG_OUT : TRACKING_EVENTS.LOGIN;
    trackEvent(event, {
      eventAction: TRACKING_ACTIONS[event],
      eventCategory: TRACKING_CATEGORIES.ODDSCHECKER_ACCOUNT,
      eventLabel: `My Account Log ${isLoggedIn ? 'out' : 'in'}`
    });
  };

  const subscription = subscriptions?.find(
    (subscription) =>
    subscription.name === 'Oddschecker+ Monthly' ||
    subscription.name === 'Oddschecker+ Annual'
  );
  const hasSubscription = !!subscription;
  const hasStripeSubscription =
  hasSubscription && subscription.provider === 'STRIPE';

  const navigateToStripe = async () => {
    try {
      const response = await fetch(
        `/api/cx/subscription/manage?returnUrl=${encodeURIComponent(window.location.href)}`
      );
      const { url } = await response.json();
      window.location.href = url;
    } catch (error) {
      console.error(error);
    }
  };

  const handleManageSubscription = () => {
    hasStripeSubscription ? navigateToStripe() : setIsDialogOpen(true);
  };

  return (
    <>
			{isLoggedIn ?
      <>
					<Popover>
						<Popover.Trigger
            aria-label="Toggle account menu"
            className={styles.trigger}>

							<AccountButton>Account</AccountButton>
						</Popover.Trigger>
						<Popover.Content>
							<ul>
								{hasSubscription &&
              <li className={styles.menuItem}>
										<Button
                  key="manage-subs"
                  onClick={handleManageSubscription}
                  ref={triggerRef}
                  variant="ghost">

											Manage Subscriptions
										</Button>
									</li>
              }
								<li className={styles.menuItem}>
									<Button
                  key="log-in"
                  onClick={openAuthenticationModal}
                  variant="ghost">

										{isLoggedIn ? 'Log out' : 'Log in'}
									</Button>
								</li>
							</ul>
						</Popover.Content>
					</Popover>
					<Dialog
          className={styles.manageSubsDialog}
          isOpen={isDialogOpen}
          setIsOpen={setIsDialogOpen}
          title="Manage Subscription Alert"
          triggerRef={triggerRef}>

						<div>
							<h2>
								<InfoIcon />
								To Unsubscribe
							</h2>
							<p>
								To manage your subscription, please visit the Settings app on
								your device and follow the required steps.
							</p>
							<div className={styles.buttonWrapper}>
								<Button
                className={styles.closeDialog}
                onClick={() => setIsDialogOpen(false)}
                variant="secondary">

									Close
								</Button>
							</div>
						</div>
					</Dialog>
				</> :

      <Button
        className={styles.trigger}
        onClick={openAuthenticationModal}
        variant="ghost">

					<AccountButton>{isLoggedIn ? 'Log out' : 'Log in'}</AccountButton>
				</Button>
      }
		</>);

};

export { MenuList };